import { Chapter, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-28 md:py-40" data-testid="about-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="01" title={t("chapters.about")} />
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-8">
          <FadeUp className="lg:col-span-7">
            <h2 className="text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem]" data-testid="about-heading">
              {t("about.headingA")} <span className="text-[#F97316]">{t("about.headingB")}</span>
            </h2>
            <p className="mt-8 max-w-lg text-sm leading-relaxed text-white/55 md:text-base">{t("about.p1")}</p>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-white/55 md:text-base">{t("about.p2")}</p>
            <div className="group mt-10 max-w-lg overflow-hidden rounded-2xl border border-white/10">
              <img
                src="/assets/team-group.jpg"
                alt={t("about.photoAlt")}
                loading="lazy"
                className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                data-testid="about-team-photo"
              />
            </div>
            <p className="mt-6 font-spacemono text-[10px] uppercase tracking-[0.25em] text-white/35">
              {t("about.entities")}
            </p>
          </FadeUp>
          <div className="lg:col-span-5">
            <FadeUp>
              <p className="mb-6 font-spacemono text-[10px] uppercase tracking-[0.3em] text-white/35">
                {t("about.specializing")}
              </p>
            </FadeUp>
            <div className="grid grid-cols-1 gap-x-8 sm:grid-cols-2">
              {t("about.specialties").map((s, i) => (
                <FadeUp key={s} delay={i * 0.05}>
                  <div
                    className="group flex items-center gap-4 border-t border-white/10 py-3.5 transition-[padding] duration-300 hover:pl-2"
                    data-testid={`about-specialty-${i + 1}`}
                  >
                    <span className="font-spacemono text-[10px] text-white/25 transition-colors duration-300 group-hover:text-[#F97316]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-syne text-sm font-bold uppercase tracking-wide text-white/80 transition-colors duration-300 group-hover:text-[#F97316]">
                      {s}
                    </span>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
